export const GROUP_OLD = [
  { id: 1, name: "Microblading" },
  { id: 2, name: "Powder Brow" },
  { id: 3, name: "Nano Hairstrokes" },
  { id: 4, name: "Eyeliner" },
  { id: 5, name: "Nano Lip" },
  { id: 6, name: "Permanent Makeup Combination" },
  { id: 7, name: "Makeup" },
  { id: 8, name: "Hair Service" },
  { id: 9, name: "Food & Drink" },
];

export const GROUP = [
  { id: 1, name: "Eyeliner Tattoos" },
  { id: 2, name: "Powder Brows" },
  { id: 3, name: "Microblading" },
  { id: 4, name: "Combination Brow Tattoos" },
  { id: 5, name: "Nano Hair Strokes" },
  { id: 6, name: "Lips" },
  { id: 7, name: "Eyebrow Tattoo Removal" },
  { id: 8, name: "Makeup" },
  { id: 9, name: "Hair Service" },
  { id: 10, name: "Food & Drink" },
];

export const CONSULTATION = [
  { id: 1, name: "Eyeliner Tattoos" },
  { id: 2, name: "Powder Brows" },
  { id: 3, name: "Microblading" },
  { id: 4, name: "Combination Brow Tattoos" },
  { id: 5, name: "Nano Hair Strokes" },
  { id: 6, name: "Lips" },
  { id: 7, name: "Makeup" },
  { id: 8, name: "Hair Service" },
];

export const AVAILABLE_TIME = [
  "Morning (9am - 12pm)",
  "Lunch (12pm - 2pm)",
  "Afternoon (2pm - 6pm)",
];
